import { render, staticRenderFns } from "./index.vue?vue&type=template&id=aef7a5b0"
import script from "./index.vue?vue&type=script&setup=true&lang=js"
export * from "./index.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BtnPill: require('/var/www/html/fantini/frontend-2/components/btn/pill/index.vue').default,GridCss: require('/var/www/html/fantini/frontend-2/components/grid/css/index.vue').default,GridCssEditorialMinimal: require('/var/www/html/fantini/frontend-2/components/grid/css/editorial/minimal/index.vue').default,Block: require('/var/www/html/fantini/frontend-2/components/block/index.vue').default})
